import React from 'react';
import ThemeSettingsFromApi from '../../theme/grid-style';

export const PlaceholderPage: React.FC = () => {
  return (
    <>
      <ThemeSettingsFromApi />
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        background: 'var(--base-bg)',
        padding: '40px'
      }}>
        <div style={{
          width: '120px',
          height: '120px',
          borderRadius: '50%',
          background: 'var(--accent-color)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: '32px',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)'
        }}>
          <i className="dx-icon dx-icon-box" style={{
            fontSize: '56px',
            color: '#ffffff',
            filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.2))'
          }}></i>
        </div>

        <h1 style={{
          fontSize: '28px',
          fontWeight: '700',
          color: 'var(--base-text-color)',
          marginBottom: '12px',
          textAlign: 'center'
        }}>
          Sayfa Geliştirme Aşamasında
        </h1>

        <p style={{
          fontSize: '16px',
          color: 'var(--texteditor-label-color)',
          textAlign: 'center',
          maxWidth: '500px',
          lineHeight: '1.6'
        }}>
          Bu sayfa şu anda geliştirilme aşamasındadır. Yakında kullanıma sunulacaktır.
        </p>
      </div>
    </>
  );
};

export default PlaceholderPage;
